import React, { useContext, useEffect, useReducer, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Store } from '../Store';
import useAxios from '../hooks/useAxios';
import { getError } from '../utils';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false };
    case 'UPDATE_REQUEST':
      return { ...state, loadingUpdate: true };
    case 'UPDATE_SUCCESS':
      return { ...state, loadingUpdate: false };
    case 'UPDATE_FAIL':
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};

export default function CategoryTouchList(props) {
  const axios = useAxios();
  const { state } = useContext(Store);
  const { userInfo } = state;
  const {
    resetToHead,
    setIsMostUsedProductsSelected,
    isMostUsedProductsSelected,
    categories,
    categories2,
  } = props;
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState({ _id: '' });
  const [{ loadingUpdate, loading }, dispatch] = useReducer(reducer, {
    loadingUpload: false,
    loading: false,
  });
  const [showSiralaCustomerEditor, setShowSiralaCustomerEditor] =
    useState(false);
  const [showSiralaAdminEditor, setShowSiralaAdminEditor] = useState(false);
  const [customerCategories, setCustomerCategories] = useState([]);
  const [showCategory2, setShowCategory2] = useState(false);

  useEffect(() => {
    if (selectedCategory._id && categories2 && categories2.length > 0) {
      setShowCategory2(true);
    } else {
      setShowCategory2(false);
    }
  }, [categories2]);

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const { data } = await axios.get(`/api/categories/admin/leafes/qrmenu`);
        dispatch({ type: 'FETCH_SUCCESS' });
        setCustomerCategories(data);
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL' });
      }
    };

    if (showSiralaCustomerEditor) {
      fetchData();
    }
  }, [showSiralaCustomerEditor]);

  const saveCategoryOrderHandler = async (categories, orderType) => {
    try {
      dispatch({ type: 'UPDATE_REQUEST' });

      if (categories.length > 0) {
        await axios.put(`/api/categories/ordering`, {
          categories,
          orderType,
        });
        dispatch({
          type: 'UPDATE_SUCCESS',
        });
      }

      dispatch({
        type: 'UPDATE_SUCCESS',
      });
      setShowSiralaAdminEditor(false);
      setShowSiralaCustomerEditor(false);
      toast.success('Kategoriler başarılı bir şekilde güncellendi');
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: 'UPDATE_FAIL' });
    }
  };

  return (
    <div
      id="categoryPanel"
      style={{ overflow: 'auto' }}
      className="bg-secondary border border-secondary rounded p-1  heightOfPanelTouch touchPanelCompartment scrollbar scrollbar-primary"
    >
      <Button
        onClick={() => {
          setIsMostUsedProductsSelected(true);
          setSelectedCategory({ _id: '' });
          navigate(`/order/touch?rootCategory=`);
        }}
        key="mostusedcategory"
        variant={isMostUsedProductsSelected ? 'primary' : 'light'}
        style={{
          width: '150px',
          aspectRatio: '2/1',
          margin: '0.3rem',
        }}
      >
        <span className="text-bold">{'Çok Satılanlar'}</span>
      </Button>
      {categories?.map((c) => (
        <Button
          onClick={() => {
            setIsMostUsedProductsSelected(false);
            resetToHead();
            navigate(`/order/touch?rootCategory=${c._id}`);
            setSelectedCategory(c);
            if (categories2.length > 0) {
              setShowCategory2(true);
            }
          }}
          key={c._id}
          id={'categoryButton' + c.tableNum}
          variant="light"
          style={{
            width: '150px',
            aspectRatio: '2/1',
            margin: '0.3rem',
            top: '0px',
            left: '0px',

            backgroundImage: `url('${c.image}')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '50% auto',
            backgroundPosition: '-30px 0px',
            border: '1px solid #ddd',
            borderRadius: '3px',
          }}
        >
          <div className="text-bold" style={{ textAlign: 'right' }}>
            {c.name}
          </div>
        </Button>
      ))}

      <Modal
        size="sm"
        show={showCategory2}
        onHide={() => setShowCategory2(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Alt kategori seç</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            {categories2?.map((c) => (
              <Button
                onClick={() => {
                  resetToHead();
                  navigate(`/order/touch?rootCategory=${c._id}`);
                  setShowCategory2(false);
                }}
                key={c._id}
                id={'categoryButton' + c.tableNum}
                variant={selectedCategory._id === c._id ? 'primary' : 'warning'}
                style={{
                  width: '150px',
                  aspectRatio: '2/1',
                  margin: '0.3rem',
                }}
              >
                <span className="text-bold">{c.name}</span>
              </Button>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
